// eslint-disable-next-line import/prefer-default-export
export const isProduction = process.env.REACT_APP_ENV === 'prod';
